<template>
    <div>
        <el-form :inline="true" :model="checkBalanceForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="代理商名称：">
                <el-input v-model="checkBalanceForm.agentName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table height="610px">
            <el-table-clomun prop="" label="序号"></el-table-clomun>
            <el-table-clomun prop="" label="代理商名称 "></el-table-clomun>
            <el-table-clomun prop="" label="充值金额"></el-table-clomun>
            <el-table-clomun prop="" label="剩余金额"></el-table-clomun>
            <el-table-clomun prop="" label="消费金额 "></el-table-clomun>
            <el-table-clomun prop="" label="创建人 "></el-table-clomun>
            <el-table-clomun prop="" label="创建时间"></el-table-clomun>
            <el-table-clomun prop="" label="操作 ">
                <template slot-scope="scope">
                    <el-button type="text" size="small">充值详情</el-button>
                </template>                
            </el-table-clomun>            
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            checkBalanceForm: {
                agentName: ''
            }
        }
    }
    
}
</script>
<style lang="less" scoped>

</style>

